<template>
  <v-row justify="center">
    <v-dialog
      v-model="show"
      persistent
      max-width="500"
      v-if="resolutionScreen >= 500"
    >
      <v-card>
        <v-card-title>
          <b v-if="statusrestore === 'multi'">{{
            $t("backupfileandfolder.multirestore")
          }}</b>
          <b v-else>{{ $t("backupfileandfolder.allrestore") }}</b
          ><v-spacer></v-spacer>
          <v-icon :color="color.theme" dense dark size="35">delete</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <br />
        <v-card-text v-if="statusrestore === 'multi'">
          {{ $t("backupfileandfolder.contentmultirestore") }}
        </v-card-text>
        <v-card-text v-else>
          {{ $t("backupfileandfolder.contentallrestore") }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" @click="$emit('closedialog')" outlined>{{
            $t("backupfileandfolder.cancelrestore")
          }}</v-btn>
          <v-btn
            v-if="statusrestore === 'multi'"
            color="green darken-1 white--text"
            depressed
            @click="$emit('multirestore')"
            >{{ $t("balloon.restore") }}</v-btn
          >
          <v-btn
            v-else
            color="green darken-1 white--text"
            depressed
            @click="$emit('allrestore')"
            >{{ $t("balloon.restore") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="show"
      v-else
      persistent
      :max-width="maxWidthOnMobile"
      content-class="rounded-lg"
    >
      <v-card>
        <v-card-text class="pa-5 text-center">
          <v-layout class="pt-2 pb-4">
            <v-flex d-flex justify-center class="ml-8">
              <span
                v-if="statusrestore === 'multi'"
                :style="headerPageDialog"
                >{{ $t("backupfileandfolder.multirestore") }}</span
              >
              <span v-else :style="headerPageDialog">{{
                $t("backupfileandfolder.allrestore")
              }}</span>
            </v-flex>
            <v-flex xs1 d-flex justify-end>
              <v-icon :color="color.theme" @click="$emit('closedialog')"
                >mdi-close</v-icon
              >
            </v-flex>
          </v-layout>
          <v-icon color="#FAAD14" size="90" class="mb-4"
            >mdi-alert-circle-outline</v-icon
          >
          <br />
          <span v-if="statusrestore === 'multi'" :style="titleText">
            {{ $t("backupfileandfolder.contentmultirestore") }}</span
          >
          <span v-else :style="titleText">{{
            $t("backupfileandfolder.contentallrestore")
          }}</span>
          <div class="text-center mt-6">
            <v-btn
              :style="btnAction"
              class="mr-2"
              height="40px"
              width="47%"
              color="red"
              outlined
              @click="$emit('closedialog')"
              >{{ $t("backupfileandfolder.cancelrestore") }}</v-btn
            >
            <v-btn
              v-if="statusrestore === 'multi'"
              class="elevation-0"
              :style="btnAction"
              height="40px"
              width="47%"
              :color="color.theme"
              :dark="color.darkTheme"
              @click="$emit('multirestore')"
              >{{ $t("balloon.restore") }}</v-btn
            >
            <v-btn
              v-else
              class="elevation-0"
              :style="btnAction"
              height="40px"
              width="47%"
              :color="color.theme"
              :dark="color.darkTheme"
              @click="$emit('allrestore')"
              >{{ $t("balloon.restore") }}</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import gbfGenerate from "@/globalFunctions/generateAuthorize";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  data() {
    return {
      loaddataprogress: false,
      password: "",
      showpassword: false,
    };
  },
  props: ["show", "statusrestore"],
  computed: {
    ...mapState([
      "username",
      "authorize",
      "account_active",
      "color",
      "role_level",
    ]),
    ...mapState({ processloader: "loading" }),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
    ]),
    resolutionScreen() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 220;
        case "sm":
          return 400;
        case "md":
          return 500;
        case "lg":
          return 600;
        case "xl":
          return 800;
      }
    },
    // style อักษรใน dialog ของ mobile
    titleText() {
      return "font-size: 16px; line-height: 24px;";
    },
    // style ปุ่ม ของ mobile
    btnAction() {
      return "font-size: 16px; font-weight: lighter;";
    },
    // style อักษรแสดงการลบเสร็จสิ้น ของ mobile
    deletesuccess() {
      return "color:#58A144; font-size: 18px; line-height: 24px;";
    },
    // style อักษร header ของ mobile
    headerPageDialog() {
      return (
        "color:" +
        this.color.theme +
        ";" +
        "font-size: 16px; font-weight: 600; font-weight: bold; letter-spacing: 0px;"
      );
    },
    // ความกว้างของ dialog ของ ipad และ mobile
    maxWidthOnMobile() {
      if (this.resolutionScreen >= 400) {
        return 600;
      } else {
        return 346;
      }
    },
  },
};
</script>
<style></style>
